import Sidebar from '../utill/Sidebar'
import Header from "../utill/Header";
import Footer from "../utill/Footer";
import {Card, Form, Table} from "react-bootstrap";
import React, {useState, useEffect, useContext, ChangeEvent} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import axios from "axios";
import Url from "../utill/Url";
import {useSelector} from "react-redux";
import {reissue} from "../utill/UtilComponent";
import styles from "../../css/Authority.module.css";
import {RootState} from "../../redux/store";

function PopupModify() {
    const url = useContext(Url)
    const location = useLocation();
    const navigate = useNavigate();
    const selectedId = location.state?.id
    const nowUser = useSelector((state: RootState) => state.user.value);
    const [disabled, setDisabled] = useState(false);
    const [onceDisabled, setOnceDisabled] = useState(false);
    const [popup, setPopup] = useState<any>([]);
    let userId = nowUser.id;
    const auth = useSelector((state: RootState) => state.loginAuth.value);


    useEffect(() => {
        document.title = 'Mcon 모니터링 시스템-팝업 수정'
        if (auth.MENUAUTH?.POP0000?.writeAuthorityYn !== "1" && auth.MENUAUTH?.POP0000?.readAuthorityYn !== "1") {
            alert('페이지를 볼 수 있는 권한이 없습니다.')
            navigate(auth.firstUrl);
        } else if (auth.MENUAUTH?.POP0000?.writeAuthorityYn !== "1") {
            navigate('/PopupManagement');
        }
        reissue(userId, url, navigate).then(() => {
            axios.get(url + 'popup/view', {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                },
                params: { id: selectedId }
            }).then((response) => {
                setPopup(response.data.result)
            })
        })
    }, []);

    useEffect(() => {
        if (popup.os === 'ios' || popup.os === "all") {
            setDisabled(true);
        } else {
            setDisabled(false);
        }
    }, [popup.os]);

    const handlePopupChange = (e: ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        // 숫자 입력 필드에 대해 숫자만 허용
        if (name === 'minSdkVersion' || name === 'maxSdkVersion') {
            if (value === '' || /^[0-9]*$/.test(value)) { // 빈 문자열 또는 숫자만 허용
                setPopup({
                    ...popup,
                    [name]: value
                });
            }
        } else {
            setPopup({
                ...popup,
                [name]: value
            });
        }
    };

    useEffect(() => {
        if (popup.cancelable === 1) {
            setOnceDisabled(true);
            popup.displayOnce = 1
        } else if (popup.cancelable === 0) {
            setOnceDisabled(false);
        }
    }, [popup.cancelable]);

    const handleAnswerChange = (value: number) => {
        setPopup({
            ...popup,
            cancelable: value
        });
    };


    const handleOnceChange = (value: number) => {
        setPopup({
            ...popup,
            displayOnce: value
        })
    }

    const handleOsChange = (osVersion: string) => {
        setPopup({
            ...popup,
            os: osVersion
        });
    };

    const popupSubmitError = (popup: any) => {
        if (!popup.title || !popup.content) {
            return '제목과 내용은 필수 값입니다.';
        }

        if (popup.os === 'android') {
            if ((popup.minSdkVersion && !popup.maxSdkVersion) || (!popup.minSdkVersion && popup.maxSdkVersion)) {
                return '최소 SDK 버전과 최대 SDK 버전은 동시에 입력 되어야 합니다.';
            }
            // appVersion이 입력되었을 경우, minSdkVersion과 maxSdkVersion이 둘 다 null이어도 통과 가능
            if (popup.appVersion && (!popup.minSdkVersion && !popup.maxSdkVersion)) {
                return null;
            } else if (popup.appVersion && (!popup.minSdkVersion || !popup.maxSdkVersion)) {
                return '최소 SDK 버전과 최대 SDK 버전은 동시에 입력 되어야 합니다.';
            }
        } else if (popup.os === 'ios' || popup.os === 'all') {
            return null;
        }
        return null;
    }

    const handleUpdatePopup = async (e: React.MouseEvent<HTMLButtonElement>) => {
        reissue(userId, url, navigate).then(() => {
            e.preventDefault();
            const popupError = popupSubmitError(popup);
            if (popupError) {
                alert(popupError);
                return;
            } else {
                const Update = window.confirm('수정하시겠습니까?');
                if (Update) {
                    if (popup.os === 'android'){
                    axios.put(url + 'popup/update', {
                        id: selectedId,
                        title: popup.title,
                        content: popup.content,
                        cancelable: popup.cancelable,
                        displayOnce: popup.displayOnce,
                        minSdkVersion: popup.minSdkVersion,
                        maxSdkVersion: popup.maxSdkVersion,
                        appVersion: popup.appVersion,
                        os: popup.os,
                        bold: popup.bold
                    }, {
                        headers: {
                            'Authorization': localStorage.getItem('Authorization')
                        }
                    })
                        .then(res => {
                            alert('수정되었습니다.');
                            navigate('/PopupManagement');
                        })
                    } else if (popup.os === 'ios' || popup.os === 'all') {
                    axios.put(url + 'popup/update', {
                        id: selectedId,
                        title: popup.title,
                        content: popup.content,
                        cancelable: popup.cancelable,
                        displayOnce: popup.displayOnce,
                        minSdkVersion: 0,
                        maxSdkVersion: 0,
                        appVersion: '',
                        os: popup.os,
                        bold: popup.bold
                    }, {
                        headers: {
                            'Authorization': localStorage.getItem('Authorization')
                        }
                    })
                        .then(res => {
                            alert('수정되었습니다.');
                            navigate('/PopupManagement');
                        })
                    }
                } else {
                    console.log(e);
                }
            }
        })
    }

    const handleDeletePopup = () => {
        reissue(userId, url, navigate).then(() => {
            const Delete = window.confirm('삭제 하시겠습니까?');
            if (Delete) {
                try {
                    axios.delete(url + `popup/delete/${selectedId}`, {
                        headers: {
                            'Authorization': localStorage.getItem('Authorization')
                        },
                        params: { id: selectedId }
                    })
                        .then(res => {
                            alert('삭제 되었습니다.');
                            navigate('/PopupManagement')
                        })
                } catch (e) {
                    console.error(e);
                    alert('삭제 실패 하였습니다.');
                }
            }
        })
    }

    const handleModifyCancel = () => {
        reissue(userId, url, navigate).then(() => {
            const Cancel = window.confirm('수정을 취소 하시겠습니까?');
            if (Cancel) {
                navigate('/PopupManagement');
            }
        })
    }

    return (
        <div id="wrapper">
            <Sidebar menuCode={"POP0000"}/>
            <div id="content-wrapper" className="d-flex flex-column">
                <div id="content">
                    <div className="container-fluid">
                        <Header pageName='팝업 수정'/>
                        <Card className="card shadow mb-4">
                            <Card.Body style={{margin:'1rem'}}>
                                <Table bordered>
                                <tbody>
                                <tr>
                                    <td style={{width: '20%'}} className={styles.tableHead}>
                                        <Form.Label><p className="after_required">제목</p></Form.Label>
                                    </td>
                                    <td style={{width: '80%'}}>
                                        <Form.Control type="text" placeholder="제목" name="title"
                                                      value={popup.title} onChange={handlePopupChange}/>
                                    </td>
                                </tr>
                                <tr>
                                    <td className={styles.tableHead} style={{height:'3rem', verticalAlign:'middle'}}>
                                        <Form.Label><p className="after_required">취소버튼 여부</p></Form.Label>
                                    </td>
                                    <td style={{verticalAlign: 'middle'}}>
                                        <Form.Group className="d-flex">
                                            <div className="d-flex align-items-center me-3">
                                                <Form.Check
                                                    type="radio"
                                                    id="yes-checkbox"
                                                    name="cancelable"
                                                    checked={popup.cancelable === 1}
                                                    onChange={() => handleAnswerChange(1)}
                                                    inline
                                                />
                                                <label htmlFor="yes-checkbox">Y</label>
                                            </div>

                                            <div className="d-flex align-items-center">
                                                <Form.Check
                                                    type="radio"
                                                    id="no-checkbox"
                                                    name="cancelable"
                                                    checked={popup.cancelable === 0}
                                                    onChange={() => handleAnswerChange(0)}
                                                    inline
                                                />
                                                <label htmlFor="no-checkbox">N</label>
                                            </div>
                                        </Form.Group>
                                    </td>
                                </tr>
                                <tr>
                                    <td className={styles.tableHead} style={{height:'3rem', verticalAlign:'middle'}}>
                                        <Form.Label><p className="after_required">표출 횟수</p></Form.Label>
                                    </td>
                                    <td style={{verticalAlign: 'middle'}}>
                                        <Form.Group className="d-flex">
                                            <div className="d-flex align-items-center me-3">
                                                <Form.Check
                                                    type="radio"
                                                    id="yes-checkbox"
                                                    name="displayOnce"
                                                    checked={popup.displayOnce === 1}
                                                    onChange={() => handleOnceChange(1)}
                                                    disabled={onceDisabled}
                                                    inline
                                                />
                                                <label htmlFor="yes-checkbox">1회</label>
                                            </div>

                                            <div className="d-flex align-items-center">
                                                <Form.Check
                                                    type="radio"
                                                    id="no-checkbox"
                                                    name="displayOnce"
                                                    checked={popup.displayOnce === 0}
                                                    onChange={() => handleOnceChange(0)}
                                                    disabled={onceDisabled}
                                                    inline
                                                />
                                                <label htmlFor="no-checkbox">항상</label>
                                            </div>
                                        </Form.Group>
                                    </td>
                                </tr>
                                <tr>
                                    <td className={styles.tableHead}><Form.Label><p>최소 SDK 버전</p></Form.Label></td>
                                    <td>
                                        <Form.Control placeholder="최소 SDK 버전" type="number" name="minSdkVersion" disabled={disabled}
                                                      value={popup.minSdkVersion === 0 ? '' : popup.minSdkVersion} onChange={handlePopupChange}/>
                                    </td>
                                </tr>
                                <tr>
                                    <td className={styles.tableHead}><Form.Label><p>최대 SDK 버전</p></Form.Label></td>
                                    <td>
                                        <Form.Control placeholder="최대 SDK 버전" type="number" name="maxSdkVersion" disabled={disabled}
                                                       value={popup.maxSdkVersion === 0 ? '' : popup.maxSdkVersion} onChange={handlePopupChange}/>
                                    </td>
                                </tr>
                                <tr>
                                    <td className={styles.tableHead}><Form.Label><p>Mcon 버전</p></Form.Label></td>
                                    <td>
                                        <Form.Control placeholder="Mcon 버전" type="text" name="appVersion" disabled={disabled}
                                                       value={popup.appVersion} onChange={handlePopupChange}/>
                                    </td>
                                </tr>
                                <tr>
                                    <td className={styles.tableHead} style={{height:'3rem', verticalAlign:'middle'}}>
                                        <Form.Label><p className="after_required">OS</p></Form.Label>
                                    </td>
                                    <td style={{verticalAlign: 'middle'}}>
                                        <Form.Group className="d-flex">
                                            <div className="d-flex align-items-center me-3">
                                                <Form.Check
                                                    type="radio"
                                                    id="android-checkbox"
                                                    name="os"
                                                    checked={popup.os === 'android'}
                                                    onChange={() => handleOsChange('android')}
                                                    inline
                                                />
                                                <label htmlFor="android-checkbox">android</label>
                                            </div>

                                            <div className="d-flex align-items-center me-3">
                                                <Form.Check
                                                    type="radio"
                                                    id="ios-checkbox"
                                                    name="os"
                                                    checked={popup.os === 'ios'}
                                                    onChange={() => handleOsChange('ios')}
                                                    inline
                                                />
                                                <label htmlFor="ios-checkbox">ios</label>
                                            </div>

                                            <div className="d-flex align-items-center">
                                                <Form.Check
                                                    type="radio"
                                                    id="all-checkbox"
                                                    name="os"
                                                    checked={popup.os === 'all'}
                                                    onChange={() => handleOsChange('all')}
                                                    inline
                                                />
                                                <label htmlFor="all-checkbox">all</label>
                                            </div>
                                        </Form.Group>
                                    </td>
                                </tr>
                                <tr>
                                    <td className={styles.tableHead} style={{verticalAlign:'middle'}}><Form.Label><p className="after_required">내용</p></Form.Label></td>
                                    <td>
                                        <Form.Control type="text" placeholder="내용" name="content" style={{height:"10rem"}}
                                                      as="textarea" value={popup.content} onChange={handlePopupChange}/>
                                    </td>
                                </tr>
                                <tr>
                                    <td className={styles.tableHead}><Form.Label><p>Bold 내용</p></Form.Label></td>
                                    <td>
                                        <Form.Control placeholder="Bold 내용" type="text" name="bold"
                                                      value={popup.bold} onChange={handlePopupChange}/>
                                    </td>
                                </tr>
                                </tbody>
                                </Table>
                                <div className="btn modify">
                                    <button className="btn btn-primary"
                                            onClick={handleUpdatePopup}>수정</button>
                                    <button className="btn btn-danger"
                                            onClick={handleDeletePopup}>삭제</button>
                                    <button className="btn btn-secondary cancel"
                                            onClick={handleModifyCancel}>취소</button>
                                </div>
                            </Card.Body>
                        </Card>
                    </div>
                </div>
                <Footer/>
            </div>
        </div>
    )
}

export default PopupModify;